module.exports = __webpack_public_path__ + "img/4_30.86de6cfc.png";